import * as React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { logout } from 'actions/shellActions';

const logoutStyle = {
    cursor: 'pointer',
};

export const LogoutLinkComponent = ({ onClick, t }: DispProps & TranslateProps) =>
    <span
        id="logout"
        onClick={ onClick }
        tabIndex={ 0 }
        style={ logoutStyle }
    >
        { t('6.1241.0.89') }
    </span>
;

export type DispProps = {
    onClick: () => void;
};

export const LogoutLink = compose<DispProps & TranslateProps, {}>(
    translate(),
    connect(null, { onClick: logout })
)(LogoutLinkComponent);



// WEBPACK FOOTER //
// ./src/ui/main/header/LogoutLink.tsx